export const pageName = {
	attributes: 'Attributes',
	body: 'Body',
	forms: 'Forms',
	changes: 'Changes',
	compare: 'Compare',
	configurations: 'Configurations',
	conclusion: 'Conclusion',
	cookieSettings: 'Cookie Settings',
	details: 'Details',
	document: 'Document',
	errorPage: 'Error Page',
	fit: 'Fit',
	guidedWorkFlow: 'Guided Workflow',
	guidedWorkFlowV2: 'Guided Workflow V2',
	header: 'Header',
	independence: 'Independence',
	print: 'Print',
	profile: 'Profile',
	section: 'Section',
	standAlone: 'Stand Alone',
	summary: 'Summary',
	view: 'View'
};

export const siteSection = {
	attributes: 'Attributes',
	changes: 'Changes',
	compare: 'Compare',
	configurations: 'Configurations',
	consent: 'Consent',
	details: 'Details',
	document: 'Document',
	documentHeader: 'DocumentHeader',
	documentSection: 'DocumentSection',
	errorPage: 'Error Page',
	fit: 'Fit',
	forms: 'Forms',
	guidedWorkFlow: 'Guided Workflow',
	guidedWorkFlowV2: 'Guided Workflow V2',
	independence: 'Independence',
	initProfile: 'Init Profile',
	print: 'Print',
	profile: 'Profile',
	standAlone: 'Stand Alone',
	documentSummary: 'DocumentSummary',
	compareDocument: 'CompareDocument',
	view: 'View'
};
